import React, { Component } from 'react';
import LayerPopup from '../../../library/layerpopup';
import { routes } from '../../../constants/routes';

class ApplyModal extends Component {
  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);
  }

  onClick(e, type) {
    e.preventDefault();
    if (type === 'OK') {
      return this.props.history.push(routes.wink.paidStudy);
    }
    LayerPopup.hide(this.props.layerKey);
  }

  render() {
    return (
      <div
        className="layer-wrap small reference-room-apply-modal"
        style={{ marginTop: '-246px' }}
      >
        <div className="layer-download">
          <p>
            해당 자료는
            <br />
            윙크 유료학습 서비스에 가입한 정회원만
            <br />
            이용 가능합니다.
          </p>
          <div className="btn-area">
            <a
              href="#"
              className="btn-type2"
              onClick={(e) => this.onClick(e, 'CANCEL')}
            >
              취소
            </a>
            <a
              href="#"
              className="btn-type2 confirm"
              onClick={(e) => this.onClick(e, 'OK')}
            >
              유료학습 신청
            </a>
          </div>
        </div>
        <button className="close" onClick={(e) => this.onClick(e, 'CANCEL')}>
          팝업 닫기
        </button>
      </div>
    );
  }
}

export default ApplyModal;
